import { observer } from "mobx-react";
import React from "react";
import { SecuredMenuItem } from "../Secured";
import { Theme, WithStyles } from "@material-ui/core";
import createStyles from "@material-ui/core/styles/createStyles";
import withStyles from "@material-ui/core/styles/withStyles";

const styles = (theme: Theme) =>
  createStyles({
    menuItem: {
      width: "100%"
    },
    title: {
      float: "left",
      marginRight: 5,
      marginTop: 3
    },
    icon: {
      float: "right"
    }
  });

export interface SecuredMenuFuncButtonProps extends WithStyles<typeof styles> {
  children: React.ReactElement;
  callbackFunction: (e: any) => void;
  title: string;
  requiredAccess?: string;
}

@observer
class SecuredMenuFunctionalButtonComponent extends React.Component<
  SecuredMenuFuncButtonProps
> {
  public render() {
    const { classes } = this.props;
    return (
      <SecuredMenuItem
        key={this.props.title.toLowerCase()}
        onClick={this.props.callbackFunction}
        requiredAccess={this.props.requiredAccess || "editable"}
      >
        <div className={classes.menuItem}>
          <div className={classes.title}>{this.props.title}</div>
          <div className={classes.icon}>{this.props.children}</div>
        </div>
      </SecuredMenuItem>
    );
  }
}

export const SecuredMenuFunctionalButton = withStyles(styles, {
  withTheme: true
})(SecuredMenuFunctionalButtonComponent);
